import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'

class ChatServices extends BaseService {
  constructor() {
    super(apiroutes.CHATS)
  }

  async getRooms(params = {}) {
    return await super.customCall('GET', '', null, params, null)
  }

  async createRoom(payload) {
    return await super.customCall('POST', '', payload, null, 'json')
  }

  async getRoomById(roomId) {
    return await super.customCall('GET', `/${roomId}`, null, null, null)
  }

  async deactivateRoom(roomId) {
    return await super.customCall('DELETE', `/${roomId}`, null, null, null)
  }

  async addParticipant(roomId, userId) {
    return await super.customCall('POST', `/${roomId}/participants`, { user_id: userId }, null, 'json')
  }

  async removeParticipant(roomId, userId) {
    return await super.customCall('DELETE', `/${roomId}/participants/${userId}`, null, null, null)
  }

  async getMessages(roomId, params = {}) {
    return await super.customCall('GET', `/${roomId}/messages`, null, params, null)
  }

  async searchMessages(roomId, params = {}) {
    return await super.customCall('GET', `/${roomId}/messages/search`, null, params, null)
  }

  async sendMessage(roomId, payload) {
    return await super.customCall('POST', `/${roomId}/messages`, payload, null, 'json')
  }

  async editMessage(roomId, messageId, payload) {
    return await super.customCall('PATCH', `/${roomId}/messages/${messageId}`, payload, null, 'json')
  }

  async deleteMessage(roomId, messageId) {
    return await super.customCall('DELETE', `/${roomId}/messages/${messageId}`, null, null, null)
  }

  async addReaction(roomId, messageId, emoji) {
    return await super.customCall('POST', `/${roomId}/messages/${messageId}/reactions`, { emoji }, null, 'json')
  }

  async removeReaction(roomId, messageId, emoji) {
    return await super.customCall('DELETE', `/${roomId}/messages/${messageId}/reactions/${encodeURIComponent(emoji)}`, null, null, null)
  }

  async readMessage(roomId, messageId) {
    return await super.customCall('POST', `/${roomId}/messages/${messageId}/read`, {}, null, 'json')
  }

  async markAllAsRead(roomId) {
    return await super.customCall('POST', `/${roomId}/read-all`, {}, null, 'json')
  }

  async uploadAttachment(roomId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return await super.customCall('POST', `/${roomId}/attachments`, formData, null, 'multipart')
  }

  async getBoardNotes(roomId, params = {}) {
    return await super.customCall('GET', `/${roomId}/board-notes`, null, params, null)
  }

  async createBoardNote(roomId, payload) {
    return await super.customCall('POST', `/${roomId}/board-notes`, payload, null, 'json')
  }

  async updateBoardNote(roomId, noteId, payload) {
    return await super.customCall('PATCH', `/${roomId}/board-notes/${noteId}`, payload, null, 'json')
  }

  async deleteBoardNote(roomId, noteId) {
    return await super.customCall('DELETE', `/${roomId}/board-notes/${noteId}`, null, null, null)
  }
}

const chatServices = new ChatServices()
export default chatServices
